const flipCards = document.querySelectorAll('.block-card-image-link--flip');

flipCards.forEach((card) => {
	const toggle = card.querySelector('.block-card-image-link__flip-toggle');

	if (!toggle) return;

	const back = card.querySelector('.block-card-image-link__back');

	const setFlipped = (isFlipped) => {
		card.classList.toggle('is-flipped', isFlipped);
		toggle.setAttribute('aria-expanded', String(isFlipped));
		toggle.setAttribute(
			'aria-label',
			isFlipped ? 'Collapse card' : 'Expand card'
		);

		if (back) {
			back.setAttribute('aria-hidden', String(!isFlipped));
		}
	};

	toggle.addEventListener('click', (e) => {
		e.preventDefault();
		setFlipped(!card.classList.contains('is-flipped'));
	});

	if (back) {
		back.addEventListener('click', () => {
			setFlipped(false);
		});
	}
});
